<template>
  <div class="goodsList-recommend">
    <div class="goodsList-recommend-title">
      <h3>产品推荐</h3>
    </div>
    <div class="goodsList-recommend-list">
      <template  v-for="(item, index) in list">
        <div
          class="goodsList-recommend-item"
          v-if="index < loop"
          :key="index"
        >
          <a
            :href="`goodsDetail?goods_id=${item.goods_id}`"
            target="_blank"
            class="goodsList-recommend-picture-box"
            :title="item.title"
          >
            <img :src="item.thumbnail" class="goodsList-recommend-picture" />
          </a>
          <a
            :href="`goodsDetail?goods_id=${item.goods_id}`"
            target="_blank"
            class="goodsList-recommend-name"
            :title="item.title"
          >
            {{ item.title }}
          </a>
          <div class="goodsList-recommend-price" v-show="isLogin">
            <div class="goodsList-recommend-price-item" v-if="item.price_type == 1">
              <strong><em>￥</em> {{ item.price | productPrice(priceFormatEnabled) }}</strong>
            </div>
            <div class="goodsList-recommend-price-item" v-else-if="item.price_type == 2">
              <span>活动价：<strong><em>￥</em> {{ item.prom_price | productPrice(priceFormatEnabled) }}</strong></span>
            </div>
            <div class="goodsList-recommend-price-item" v-else>
              <span>协议价：<strong><em>￥</em> {{ item.agreement_price | productPrice(priceFormatEnabled) }}</strong></span>
              <span>平台价：<del><em>￥</em>{{ item.price | productPrice(priceFormatEnabled) }}</del></span>
            </div>
            <img
              :src="'icon_car.png' | imagePath"
              class="pointer"
              @click="cartAdd($event, index)"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: [],
    },
    priceFormatEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loop:7,
      isLogin: this.$.user.userLogin()
    };
  },
  methods: {
    cartAdd(e, index) {
      this.$emit("change", {
        type: "addCart",
        val: index,
      });
    },
  },
};
</script>

<style>
.goodsList-recommend-title {
  height: 60px;
  padding: 0 20px;
  background-color: #f5f5f5;
  display: flex;
  align-content: center;
}
.goodsList-recommend-title h3 {
  font-size: 14px;
  line-height: 60px;
  font-weight: bold;
  display: block;
  height: auto;
}
.goodsList-recommend-picture-box {
  width: 200px;
  height: 200px;
  margin: auto;
}
.goodsList-recommend-picture-box img {
  width: 150px;
  height: 150px;
  margin: auto;
  display: block;
}
.goodsList-recommend-price {
  font-size: 16px;
  color: #e60012;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.goodsList-recommend-name {
  color: #333333;
  font-size: 14px;
  margin: 10px 0;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goodsList-recommend-item {
  padding: 15px 20px;
  border-bottom: 1px solid #eeeeee;
}
.recommend-price {
  font-size: 18px;
}
.goodsList-recommend-price-item{
    flex-grow: 1;
    margin-right: 10px;
  }
  .goodsList-recommend-price-item span{
    color: #999999;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  .goodsList-recommend-price-item strong{
    color: #E60012;
    font-size: 22px;
  }
  .goodsList-recommend-price-item strong em{
    font-size: 16px;
  }
.goodsList-recommend-price .pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ListRecommend/index.vue